export const setNProgressColor = (color: string) => {
  const style = document.createElement('style');
  style.textContent = `#nprogress .bar { background: ${color} !important;}`;
  document.body.appendChild(style);
};
